import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useRef } from 'react';

import { 
    Grid,
    Typography,
    Paper,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    IconButton
} from "@material-ui/core";
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import moment from 'moment';

import AddButtonComprobante from '../UI/AddButtonComprobante';
import TableGeneric from '../../compartidos/abms/TableGeneric';
import ToolbarXLSPDF from '../../compartidos/ToolbarXLSPDF';
import { 
    deleteComprobanteMesaEntrada,
    getExpedientes,
    getProformas,
    postComprobanteMesaEntrada,
} from '../../../actions/mesaEntrada/mesaEntradaActions';
import { fetchCuentasContables } from '../../../actions/contrataciones/contratacionesDatosContables';
import DeleteButtonAbm from '../../compartidos/abms/DeleteButtonAbm';
import { ImpresionComprobante } from '../UI/ImpresionComprobante';
import { StepperFormExpediente } from './StepperFormExpediente';
import { generateExcelMesaEntrada, generatePDFMesaEntrada } from '../../../actions/mesaEntrada/documentacionMesaEntradaActions';
import { MESA_ENTRADA_PERMISOS } from '../../../utils/permisos';
import { MesaEntradaAccordionProformas } from './Accordions/MesaEntradaAccordionProformas';
import { startAlerta } from '../../../actions/ui/alertas';
import { checkProformaValues } from '../data/datosProformaForm';
import ChevronDown from '../../autorizaciones/UI/ChevronDown';
import { ESTADOS_COMRPOBANTES, TIPO_COMPROBANTE, TIPO_EFECTORES } from '../../../utils/constants';
import { validarSoloUnPermiso } from '../../../helpers/permisos';
import IconEstado from '../../autorizaciones/UI/IconEstado';
import { getPresupuestosAutorizadosMesaEntrada } from '../../../actions/mesaEntrada/presupuestosMesaEntrada';
import { MesaEntradaAccordionPresupuestos } from './Accordions/MesaEntradaAccordionPresupuestos';
import { MesaEntradaAccordionCotizaciones } from './Accordions/MesaEntradaAccordionCotizaciones';
import { getCotizacionesAceptadasMesaEntrada } from '../../../actions/mesaEntrada/cotizacionesMesaEntrada';

const validators = [
    "required",
    "minStringLength:10",
    "maxStringLength:100"
];
const errorMessages = [
    "Debe ingresar un motivo de baja",
    "El motivo de baja debe tener al menos 10 caracteres",
    "El motivo de baja no debe tener más de 100 caracteres"
];

export const ComprobantesPrestadores = () => {
    const dispatch = useDispatch();

    const { permisos:permisosUser } = useSelector(state => state.auth);
    const { dataContrato } = useSelector((state) => state.contrataciones);
    const { proformas, proformaTomada, tipoEfectorMenu, presupuestos, cotizaciones } = useSelector(state => state.mesaEntrada);
    const comprobantes = useSelector(state => state.mesaEntrada.comprobantes.filter(item => item.idTipoComprobante !== TIPO_COMPROBANTE.PROFORMA));
    console.log(cotizaciones);
    const [expandedPresupuestos, setExpandedPresupuestos] = useState(presupuestos?.length > 0);

    const [motivoBaja, setMotivoBaja] = useState({
        active: true,
        text: ""
    });

    const componentRef = useRef();

    const validation = (values) => {
        try {
            if(moment(values.fechaFinVigencia) < moment(values.fechaRecepcion)) throw new Error('La fecha de vencimiento no puede ser menor a la fecha recepcion.');
            if(moment(values.fechaFinVigencia) < moment(values.fechaInicioVigencia)) throw new Error('La fecha de vencimiento no puede ser menor a la fecha de comprobante.');

            return true;
        } catch (error) {
            dispatch(startAlerta(error.message,'error','Error'));
        }
    }

    const handleSave = (formValues, stepperMenu, presupuesto) => {
        if(validation(formValues)){
            // const data = 
            //     tipoEfectorMenu  === TIPO_EFECTORES.CONTRATO_PRESTADORES
            //         ?   {...formValues,
            //                 idDestino:
            //                     formValues.internacion
            //                         ? DESTINOS_COMPROBANTE.AUDITORIA_MEDICA 
            //                     : formValues.ambulatoria
            //                         ? DESTINOS_COMPROBANTE.LIQUIDACIONES
            //                         : formValues.idDestino
            //             }
            //         : formValues;
                    
            if(proformaTomada !== null){
                const checked = checkProformaValues(formValues, proformaTomada, tipoEfectorMenu);
                if(checked === true){
                    dispatch(postComprobanteMesaEntrada(formValues, stepperMenu, presupuesto));
                }else{
                    dispatch(startAlerta(`La proforma que desea asignar no coincide con los datos del comprobante`,'error'));
                }
            }else{
                dispatch(postComprobanteMesaEntrada(formValues, stepperMenu));
            }
        }
    }

    const handleDelete = (idExpediente) => {
        dispatch(deleteComprobanteMesaEntrada({idExpediente, motivoBaja: motivoBaja.text}));
    };

    useEffect(() => {
        if(dataContrato !== null && dataContrato?.idEfectorFacturacion){
            dispatch(getExpedientes());
            dispatch(getProformas());
            if(tipoEfectorMenu === TIPO_EFECTORES.PROVEEDOR){
                dispatch(fetchCuentasContables());
                dispatch(getCotizacionesAceptadasMesaEntrada());
            };
            if(tipoEfectorMenu === TIPO_EFECTORES.CONTRATO_PRESTADORES) dispatch(getPresupuestosAutorizadosMesaEntrada(setExpandedPresupuestos));
        }
    }, [dataContrato]);

    return (
        <Grid
            container
            spacing={1}
            direction="row"
            justify="center"
            alignItems="center"
        >    
            <Grid item xs={12} md={11} style={{paddingLeft:0, marginBottom:10}}>
                <AddButtonComprobante
                    handleSave={handleSave}
                    permiso={MESA_ENTRADA_PERMISOS.ALTA}
                    form={StepperFormExpediente}
                />
            </Grid>

            {tipoEfectorMenu === TIPO_EFECTORES.PROVEEDOR && (
                <Grid item xs={12} md={11} style={{marginTop: "1em"}}>
                    <MesaEntradaAccordionCotizaciones 
                        cotizaciones={cotizaciones} 
                    />
                </Grid>
            )}

            <Grid item xs={12} md={11} style={{marginTop: "1em"}}>
                <MesaEntradaAccordionPresupuestos 
                    presupuestos={presupuestos} 
                    setExpanded={setExpandedPresupuestos}
                    expanded={expandedPresupuestos}
                />
            </Grid>
            <Grid item xs={12} md={11} style={{marginTop: "1em"}}>
                <Accordion TransitionProps={{ unmountOnExit: true }}>
                    <AccordionSummary expandIcon={<ChevronDown />}>
                        <Typography variant="h6">Proformas</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <MesaEntradaAccordionProformas 
                            proformas={proformas}
                        />
                    </AccordionDetails>
                </Accordion>
            </Grid>
            <Grid item xs={12} md={11} style={{paddingLeft:0, marginTop:20}}>
                <Grid container justify="space-between" alignItems="center" component={Paper} spacing={2}>
                    <Grid item >
                        <Typography variant="subtitle1" style={{ paddingLeft: 20 }}>
                            {tipoEfectorMenu === TIPO_EFECTORES.PROVEEDOR ? "Listado de Comprobantes Proveedores" : "Listado de Comprobantes Prestadores"}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <ToolbarXLSPDF
                            handleExportExcel={() => dispatch(generateExcelMesaEntrada(dataContrato?.idEfectorFacturacion))}
                            handleGeneratePdf={() => dispatch(generatePDFMesaEntrada(dataContrato?.idEfectorFacturacion))}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TableGeneric
                            ref={componentRef}
                            data={comprobantes}
                            withoutPagination
                            align="center"
                            columns={[
                                {
                                    label: "Elimnar Comprobante",
                                    customBody: (item) => (
                                        <>
                                            {(item.idEstado === ESTADOS_COMRPOBANTES.PENDIENTE_ENVIO || item.idEstado === ESTADOS_COMRPOBANTES.RETORNADA || item.idEstado === ESTADOS_COMRPOBANTES.PROFORMA_IMPUTADA) &&
                                             validarSoloUnPermiso(permisosUser, MESA_ENTRADA_PERMISOS.BAJA) ? (
                                                    <DeleteButtonAbm
                                                        handleDelete={() => handleDelete(item.idExpediente)}
                                                        permiso={MESA_ENTRADA_PERMISOS.BAJA}
                                                        mensajeEliminacion="¿Desea anular este comprobante?"
                                                        motivo={motivoBaja}
                                                        setMotivo={setMotivoBaja}
                                                        validators={validators}
                                                        errorMessages={errorMessages}
                                                    />
                                                ) : (
                                                    <IconButton
                                                        aria-label="Eliminar"
                                                        disabled
                                                    >
                                                        <DeleteForeverIcon sx={{ fontSize: "2rem" }} />
                                                    </IconButton>
                                                )
                                            }
                                        </>
                                    )
                                },
                                {
                                    label: "Estado Comprobante",
                                    customBody: (item) => (
                                        <IconEstado
                                            useColorTable={true}
                                            texto={item?.letra}
                                            backgroundColor={item?.color}
                                            descripcion={item?.descripcionEstado}
                                        />
                                    )
                                },
                                {
                                    label: "Fecha Ingreso",
                                    id: "fechaCarga",
                                    customBody: (item) => moment(item.fechaCarga).format("DD/MM/YYYY"),
                                },
                                {
                                    label: "Id Comprobante",
                                    id: "idExpediente",
                                },
                                {
                                    label: "Id Comprobante SV",
                                    id: "idExpedientes",
                                },
                                {
                                    label: "Fecha Recepcion",
                                    id: "FechaRecepcion",
                                    customBody: (item) => moment(item.fechaRecepcion).format("DD/MM/YYYY"),
                                },
                                {
                                    label: "Tipo Comprobante",
                                    id: "descripcionTipoComprobante",
                                },
                                {
                                    label: "N° Comprobante",
                                    id: "nroSucursal",
                                    customBody: (item) => {
                                        return item?.nroSucursal && item?.nroFactura ? (
                                            item?.descripcionTipoFactura
                                            ? `${item?.descripcionTipoFactura} / ${item?.nroSucursal.toString().padStart((5), '0')}-${item?.nroFactura.toString().padStart((8), '0')}`
                                            : `${item?.nroSucursal.toString().padStart((5), '0')}-${item?.nroFactura.toString().padStart((8), '0')}`
                                        ) : (
                                            "No posee N° Comprobante"
                                        )
                                    },
                                },
                                {
                                    label: "Total Comprobante",
                                    id: "fechaComprobante",
                                    customBody: (item) => `$ ${parseFloat(item.totalComprobante).toFixed(2)}`,
                                },
                                {
                                    label: "Fecha Comprobante",
                                    id: "fechaInicioVigencia",
                                    customBody: (item) => moment(item.fechaInicioVigencia).format("DD/MM/YYYY"),
                                },
                                {
                                    label: "Fecha Vencimiento",
                                    id: "fechaFinVigencia",
                                    customBody: (item) => moment(item.fechaFinVigencia).format("DD/MM/YYYY"),
                                },
                                {
                                    label: "Imprimir Comprobante",
                                    customBody: (item) => (
                                        <ImpresionComprobante comprobante={item} />
                                    )
                                },
                            ]}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}
